import React from 'react'
import PropTypes from 'prop-types'

function Heading (props) {
  const { children, className } = props
  return (
    <div className={`of-heading text-font-1-100${className ? ' ' + className : ''}`}>
      {children}
    </div>
  )
}

Heading.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string
}

export default Heading
